const FOCUS_RING =
  "focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2";

export const ONBOARDING_PRIMARY_BUTTON = `btn-primary-fill text-sm ${FOCUS_RING}`;

export const ONBOARDING_TEXT_BUTTON = `text-sm font-medium rounded-md px-1 py-2 disabled:opacity-50 ${FOCUS_RING}`;
